import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

const query = gql`
  {
    allNpoReportQuestions {
      edges {
        node {
          dbId
          text
          questionType
        }
      }
    }
  }
`;

export const useAllNpoReportQuestions = () => {
  const { data: rawData, refetch, loading } = useQuery(query, { fetchPolicy: 'no-cache' });
  const data = (rawData?.allNpoReportQuestions?.edges.length) > 0 ? removeConnectionsMemoized(rawData?.allNpoReportQuestions) : [];
  return { data, refetch, loading };
};
